export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12044.fb5b9c9e.jpg";